import { createFileRoute } from '@tanstack/react-router';

import { OrgTasksView } from 'src/sections/white-glove/org-tasks-view';

/**
 * The cross-brand task list (WG-54).
 *
 * Org-scoped with no client in the path: the point of the view is that it spans
 * brands, so naming one in the URL would make it the privileged one and would
 * mean the tenant switcher silently re-scoped a merged list.
 */
export const Route = createFileRoute('/_authed/dashboard/o/$orgId/white-glove/tasks')({
  component: OrgWhiteGloveTasksPage,
});

function OrgWhiteGloveTasksPage() {
  const { orgId } = Route.useParams();
  return <OrgTasksView orgId={orgId} />;
}
